import { CurrencyLabel } from 'Modules/Currency';
import { bool, objectOf, shape } from 'prop-types';
import { useSelector } from 'react-redux';

import styles from './FeeContent.less';

const FeeFixed = props => {
  const { consultFee, isViewMode } = props;

  const { estimate } = useSelector(state => state.webChat.consultFee);
  const {
    fixedFee: fixedFeeBreakdown,
    surchargeFee,
    practiceCost,
    adminFee,
    appliedAdminFee,
  } = consultFee?.consult?.status === 1 ? estimate : consultFee;

  return (
    <div>
      {!isViewMode && (
        <div className={styles.item}>
          <strong>Fee Breakdown</strong>
        </div>
      )}
      <div className={styles.feeChatContainer}>
        {appliedAdminFee ? (
          <div className={styles.item} style={{ marginTop: '0px' }}>
            <div className={styles.label}>Admin fee</div>
            <div className={styles.value}>
              <CurrencyLabel value={adminFee} />
            </div>
          </div>
        ) : (
          <>
            <div className={styles.item} style={{ marginTop: '0px' }}>
              <div className={styles.label}>Fixed Fee</div>
              <div className={styles.value}>
                <CurrencyLabel value={fixedFeeBreakdown} />
              </div>
            </div>
            {!!surchargeFee && (
              <div className={styles.item} style={{ marginTop: '0px' }}>
                <div className={styles.label}>Surcharge</div>
                <div className={styles.value}>
                  <CurrencyLabel value={surchargeFee} />
                </div>
              </div>
            )}
            {practiceCost > 0 && (
              <div className={styles.item} style={{ marginTop: '0px' }}>
                <div className={styles.label}>Practice cost</div>
                <div className={styles.value}>
                  <CurrencyLabel value={practiceCost} />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

FeeFixed.propTypes = {
  isViewMode: bool,
  consultFee: objectOf(
    shape({
      feeSetting: objectOf(shape({})).isRequired,
    }),
  ).isRequired,
};

FeeFixed.defaultProps = {
  isViewMode: false,
};

export default FeeFixed;
